<template>
  <td
    ref="cell"
    :key="isAssignees"
    :class="{
      disabled: disabled,
      validation: selectable,
      selected: selectable & selected
    }"
    :style="{
      'border-left': cellBorderLeft,
      'background': cellBackground
    }"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    @click="onClick"
  >
    <table>
      <tr>
        <td
          class="left-half"
          :style="getHalfCellStyle(true)"
        >
          <div
            class="flexrow-item"
            :key="isAssignees + left"
            :style="leftStyle"
          >
            <div
              class="wrapper"
              v-if="!minimized"
            >
              <span
                v-if="task"
              >
                <span
                  v-if="task.preview_files?.length > 0"
                  class="prev_tag"
                  :title="task.preview_files.length + ' previews'"
                >
                  {{ task.preview_files.length }}
                </span>
                <span
                  v-if="notificationCount > 0"
                  class="notif_tag"
                  :title="notificationCount + ' notifications'"
                  :style="{
                    left: task.preview_files?.length > 0 ? '4px' : '-8px'
                  }"
                >
                  {{ notificationCount }}
                </span>
                <span
                  class="tag"
                  :title="taskStatus.name"
                  :style="{
                    background: backgroundColor,
                    color: color
                  }"
                >
                  {{ taskStatus.short_name }}
                </span>
                <span
                  class="due-date"
                  :key="isDueDates + prettyDueDate"
                  v-if="isDueDates && !minimized"
                >
                  {{ prettyDueDate }}
                </span>
                <span class="priority" v-if="!isCurrentUserClient">
                  {{ priority }}
                </span>
                <span
                  class="casting-status"
                  :class="{ 'casting-status-not-ready': !isCastingReady }"
                  :title="castingTitle"
                  v-if="!isCurrentUserClient && castingTitle"
                >
                  <img src="@/assets/icons/casting-ready.png" v-if="isCastingReady" />
                  <img src="@/assets/icons/casting-not-ready.png" v-else />
                </span>
              </span>
            </div>
            <div
              class="wrapper"
              v-else
            >
              <span
                class="tag"
                :style="{
                  background: backgroundColor,
                  color: color
                }"
              >
                &nbsp;
              </span>
            </div>
          </div>
        </td>
        <multi-people-name-cell
          class="right-half"
          :style="getHalfCellStyle(false)"
          :peopleIds="assigneesHistory"
          :avatars="false"
          :highlight="assigneeId"
          :key="assigneesHistory.length"
          v-if="secondCell && isAssignees && !minimized && !isCurrentUserClient"
        />
      </tr>
    </table>
  </td>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDateSimple } from '@/lib/time'
import colors from '@/lib/colors'
import MultiPeopleNameCell from './MultiPeopleNameCell'

export default {
  name: 'validation-cell',

  data() {
    return {
      task: null,
      cellBackground: this.isBorder ? this.getBackground() : 'transparent',
      cellBorderLeft: this.isBorder ? '1px solid ' + this.column.color : 'none'
    }
  },

  components: {
    MultiPeopleNameCell
  },

  props: {
    column: {
      default: null,
      type: Object
    },
    entity: {
      default: null,
      type: Object
    },
    taskTest: {
      default: null,
      type: Object
    },
    isCastingReady: {
      default: false,
      type: Boolean
    },
    castingTitle: {
      default: '',
      type: String
    },
    isBorder: {
      default: true,
      type: Boolean
    },
    isStatic: {
      default: false,
      type: Boolean
    },
    isAssignees: {
      default: true,
      type: Boolean
    },
    isDueDates: {
      default: false,
      type: Boolean
    },
    secondCell: {
      default: false,
      type: Boolean
    },
    minimized: {
      default: false,
      type: Boolean
    },
    selectable: {
      default: true,
      type: Boolean
    },
    clickable: {
      default: true,
      type: Boolean
    },
    selected: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    rowX: {
      default: 0,
      type: Number
    },
    columnY: {
      default: 0,
      type: Number
    },
    left: {
      type: String,
      default: '0px'
    },
    sticked: {
      default: false,
      type: Boolean
    },
    canceled: {
      default: false,
      type: Boolean
    }
  },

  mounted() {
    if (this.taskTest) {
      this.task = this.taskTest
    } else if (this.entity && this.column && this.entity.validations) {
      this.task = this.taskMap.get(this.entity.validations.get(this.column.id))
    }
    this.changeStyleBasedOnSelected()
  },

  computed: {
    ...mapGetters([
      'isDarkTheme',
      'isCurrentUserClient',
      'personMap',
      'taskMap',
      // 'getTaskRevisionHistory',
      'taskStatusMap'
    ]),

    notificationCount () {
      return this.task?.notification_count
    },

    leftStyle () {
      var res = {}
      if (this.secondCell) {
        res.width = '124px'
        res['min-width'] = '124px'
        res['max-width'] = '124px'
        if (this.isAssignees) {
          res['margin-top'] = '7px'
          res['margin-bottom'] = 'auto'
        }
      }
      return res
    },

    prettyDueDate () {
      if (this.task) {
        if (this.task.due_date) {
          return formatDateSimple(this.task.due_date, 'DD.MM.YY')
        }
      }
      return 'no date'
    },

    assigneesHistory () {
      const res = []
      if (this.task) {
        if (this.task.assignees.length > 0) {
          res.push(this.task.assignees[0])
        }
        // this.getTaskRevisionHistory(this.task).forEach((revision) => {
        //   const assignees = revision.assignee_ids
        //   if (assignees.length > 0) {
        //     if (!res.includes(assignees[0])) {
        //       res.push(assignees[0])
        //     }
        //   }
        // })
        this.task.history.forEach((entry) => {
          if (entry.assign_history.length > 0) {
            entry.assign_history.forEach((ass) => {
              if (!res.includes(ass)) {
                res.push(ass)
              }
            })
          }
        })
      }
      return res
    },

    assignees () {
      if (this.task) {
        return this.task.assignees
      } else {
        return []
      }
    },

    assigneeId () {
      if (this.task) {
        if (this.task.assignees.length > 0) {
          return this.task.assignees[0]
        }
      }
      return ''
    },

    backgroundColor () {
      const isTodo = this.taskStatus.name === 'Todo'
      if (isTodo && !this.isDarkTheme) {
        return '#ECECEC'
      } else if (isTodo && this.isDarkTheme) {
        return '#5F626A'
      } else if (this.isDarkTheme && this.taskStatus.color) {
        return colors.darkenColor(this.taskStatus.color)
      } else if (this.taskStatus.color) {
        return this.taskStatus.color
      } else {
        return 'transparent'
      }
    },

    color() {
      const isTodo = this.taskStatus.name === 'Todo'
      if (!isTodo || this.isDarkTheme) {
        return 'white'
      } else {
        return '#333'
      }
    },

    priority() {
      if (this.task.priority && !this.taskStatus.is_done) {
        if (this.task.priority === 3) {
          return '!!!'
        } else if (this.task.priority === 2) {
          return '!!'
        } else if (this.task.priority === 1) {
          return '!'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },

    taskStatus() {
      if (this.task) {
        const taskStatusId = this.task.task_status_id
        return this.taskStatusMap ? this.taskStatusMap.get(taskStatusId) : {}
      } else {
        return {}
      }
    }
  },

  methods: {
    ...mapActions([]),

    getBackground() {
      if (this.disabled) {
        return 'rgba(0, 0, 0, 0.15)'
      } else if (this.isBorder && !this.sticked) {
        const opacity = this.isDarkTheme ? 0.15 : 0.08
        return colors.hexToRGBa(this.column.color, opacity)
      } else {
        return 'inherit'
      }
    },

    getHalfCellStyle (isLeft) {
      var style = { 'vertical-align': this.isAssignees && this.secondCell ? 'top' : 'center' }
      if (isLeft) {
        var leftWidth = this.minimized ? '45px' : '150px'
        style.width = leftWidth
        style['min-width'] = leftWidth
        style['max-width'] = leftWidth
      }
      return style
    },

    onMouseOver (event) {
      if (this.selectable && !this.selected) {
        const background = this.isDarkTheme ? '#6E70CA' : '#CFD1FF'
        this.changeStyle(background)
      }
    },

    onMouseOut(event) {
      if (this.selectable && !this.selected) {
        const background = this.getBackground()
        this.changeStyle(background)
      }
    },

    onClick(event) {
      if (this.clickable) {
        this.select(event)
      }
    },

    changeStyle (background) {
      this.cellBackground = background
      this.cellBorderLeft = this.isBorder ? '1px solid ' + this.column.color : 'none'
    },

    select(event) {
      const isUserClick = event.isUserClick !== false
      if (this.selectable) {
        if (
          this.$refs.cell &&
          this.$refs.cell.className.indexOf('selected') < 0
        ) {
          this.$emit('select', {
            entity: this.entity,
            column: this.column,
            task: this.task,
            x: this.rowX,
            y: this.columnY,
            isCtrlKey: event.ctrlKey || event.metaKey,
            isShiftKey: event.shiftKey,
            isUserClick: isUserClick
          })
        } else {
          this.$emit('unselect', {
            entity: this.entity,
            column: this.column,
            task: this.task,
            x: this.rowX,
            y: this.columnY,
            isCtrlKey: event.ctrlKey || event.metaKey,
            isShiftKey: event.shiftKey,
            isUserClick: isUserClick
          })
        }
      }
    },

    avatarPath(personId) {
      const person = this.personMap.get(personId)
      if (person) {
        return person.avatarPath + '?unique=' + person.uniqueHash
      } else {
        return ''
      }
    },

    avatarKey(personId) {
      const person = this.personMap.get(personId)
      if (person) {
        return person.id + '-' + person.uniqueHash
      } else {
        return ''
      }
    },

    changeStyleBasedOnSelected() {
      if (this.selected) {
        const background = this.isDarkTheme ? '#5E60BA' : '#BFC1FF'
        this.changeStyle(background)
      } else {
        const background = this.getBackground(
          this.column ? this.column.color : 'transparent'
        )
        this.changeStyle(background)
      }
    },

    formatPriority(priority) {
      let label = priority + ''
      if (priority === 0) {
        label = 'normal'
      } else if (priority === 1) {
        label = this.$t('tasks.priority.high')
      } else if (priority === 2) {
        label = this.$t('tasks.priority.very_high')
      } else if (priority === 3) {
        label = this.$t('tasks.priority.emergency')
      }
      return label
    }
  },

  watch: {
    selected() {
      this.changeStyleBasedOnSelected()
    },

    taskTest() {
      if (this.taskTest) {
        this.task = this.taskTest
      } else if (this.entity && this.entity.validations) {
        this.task = this.taskMap.get(
          this.entity.validations.get(this.column.id)
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dark td.selected,
.dark td.selected.validation:hover {
  background-color: #8f91eb;
}

.validation {
  cursor: pointer;
  margin-bottom: 3px;
  padding: 0;
  height: 100%;
}

.wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

span.person-avatar:nth-child(2) {
  margin-left: 3px;
}

.validation-tag {
  margin-bottom: 3px;
}

.person-avatar {
  margin-right: 3px;
}

.avatar {
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;
}

.avatar span {
  flex: 1;
}

.avatar img {
  width: 20px;
  height: 20px;
}

.tag {
  font-weight: 500;
  letter-spacing: 1px;
  margin-right: 0.1em;
  margin-bottom: 0.3em;
  text-transform: uppercase;
}

.prev_tag {
  position: absolute;
  top: -8px;
  left: -8px;
  border-radius: 50%;
  width: 12pt;
  height: 12pt;
  font-size: 8pt;
  font-weight: bold;
  color: $white;
  padding-left: 5px;
  background: $blue;
}

.notif_tag {
  position: absolute;
  top: -8px;
  border-radius: 50%;
  width: 12pt;
  height: 12pt;
  font-size: 8pt;
  font-weight: bold;
  color: $white;
  padding-left: 5px;
  background: $red;
  animation-name: notif;
  animation-duration: 0.2s;
  animation-timing-function: ease-in;
}

@keyframes notif {
  0% { scale: 0; }
  80% { scale: 1.6; }
  100% { scale: 1; }
}

.priority {
  color: red;
  margin-right: 3px;
}

.disabled .tag {
  opacity: 0;
}

.casting-status {
  position: absolute;
  right: -5px;
  top: -8px;

  img {
    width: 12px;
  }
}

table {
  width: 100%;
  height: 100%;
}

.left-half {
  border: none;
}

.right-half {
  border-right: none;
  border-bottom: none;
  border-top: none;
  border-left-style: dotted;
  border-left-width: 1px;
  padding-top: 1em;
  // padding-bottom: 1em;
}
</style>
